module.exports = __webpack_public_path__ + "static/media/banner1.f1bcbf89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fetzer/images/banner1.jpg
// module id = 493
// module chunks = 0